import React, { Component } from "react";
import Map from "./Map";
import Comparer from "./Comparer";

class App extends Component {
  sendMessage = (delay) => {
    setTimeout(() => {
      const height = document.querySelector("#root").offsetHeight;
      console.log(height);
      window.parent.postMessage(["setHeight", height + 20], "*");
    }, delay);
  };
  componentDidMount() {
    [500, 1000, 2000, 3000, 4000, 5000, 10000].forEach(this.sendMessage);
  }
  render() {
    return (
      <div className="App">
        <Map />
        <Comparer />
      </div>
    );
  }
}

export default App;
